<template>
    <div>
        <b-row align-h="center" :class="{ 'blurChart': blurredChart }" class="mt-3">
            <div style="width: 100%; height: 100%;">
                <highcharts :options="chartOptions"></highcharts>
            </div>
        </b-row>
        <div v-if="blurredChart && blurredChartMsg" class="overlay">
            <b-card class="neu-card">
                <span>{{ blurredChartMsg }}</span>
            </b-card>
        </div>
    </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import hcMore from 'highcharts/highcharts-more'
import Treemap from 'highcharts/modules/treemap'
import { BCard } from 'bootstrap-vue'
import BaseInput from '../base/forms/BaseInput.vue'
import BaseModal from '@/components/base/BaseModal.vue'
import BaseButton from '@/components/base/buttons/BaseButton.vue'
import BaseDialog from '@/components/base/BaseDialog.vue'
import { SECONDARY } from '@/constants/colours'
hcMore(Highcharts)
Treemap(Highcharts)

export default {
    components: {
        'highcharts': Chart,
        BCard,
        BaseInput,
        BaseModal,
        BaseButton,
        BaseDialog
    },
    props: {
        data: {
            type: Array,
            required: true
        },
        blurredChart: {
            type: Boolean,
            default: false
        },
        blurredChartMsg: {
            type: String
        }
    },
    computed: {
        clickablePoint () {
            return !this.blurredChart
        },
        chartOptions () {
            var _this = this
            return {
                chart: {
                    type: 'treemap',
                    backgroundColor: 'transparent'
                },
                title: {
                    text: ''
                },
                legend: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    enabled: this.clickablePoint,
                    outside: true,
                    formatter: function () {
                            return `${this.point.name}: <b>${this.point.tooltipText}</b>`
                    },
                    style: {
                        fontFamily: 'Space Grotesk'
                    }
                },
                series: [{
                    layoutAlgorithm: 'squarified',
                    layoutStartingDirection: 'horizontal',
                    alternateStartingDirection: true,
                    data: this.data
                }],
                plotOptions: {
                    treemap: {
                        borderColor: SECONDARY,
                        borderRadius: '7px',
                        borderWidth: 1.5,
                        dataLabels: {
                            // padding: 2,
                            useHTML: true,
                            crop: true,
                            formatter: function () {
                                if (this.point.formatter) {
                                    return this.point.formatter
                                } else {
                                    return `<div style="text-align: center;">
                                        <span>${this.point.name.toUpperCase()}</span><br>
                                        <span>${this.point.tooltipText}</span>
                                        </div>`
                                }
                            },
                            style: {
                                fontFamily: 'Space Grotesk',
                                textOverflow: 'none'
                            }
                        },
                        point: {
                            events: {
                                click: function () {
                                    if (this.route && _this.clickablePoint) {
                                        _this.$router.push(this.route)
                                    }
                                },
                                mouseOver: function () {
                                    if (this.route && _this.clickablePoint) {
                                        this.series.chart.container.style.cursor = 'pointer'
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</script>
<style lang="scss">
    .highcharts-tooltip {
        z-index: 9999 !important;
    }
    .blurChart {
        filter: blur(15px)
    }
    .highcharts-series {
        clip-path: inset(0% 0% 0% 0%);
    }
    .overlay {
        position: absolute;
        top: 45%;
        left: 10%;
        right: 10%;
    }
</style>


// WEBPACK FOOTER //
// src/components/charts/TreemapChart.vue